import { LOCAL_STORAGE_KEYS } from '../config/constants';

export const localConfig = () => {
    function fetch() {
        let localConfig = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.main) || '{}');
        localConfig.save = save;
        return localConfig;
    }

    /**
     * @description Saves to localStorage the updated config
     * @param keyPath
     * @param newValue
     */
    function save(keyPath, newValue) {
        // let newCfg = this.setIn(keyPath, newValue);
        const config = localConfig().fetch();
        let newCfg = { ...config, [keyPath]: newValue };
        localStorage.setItem(LOCAL_STORAGE_KEYS.main, JSON.stringify(newCfg));
    }

    return {
        fetch: fetch,
    };
};
export function setAuthToken(token) {
    try {
        sessionStorage.setItem('authToken', token);
    } catch (error) {
        console.error('Error setting auth token in session storage:', error);
    }
}

export function getAuthToken() {
    try {
        return localStorage.getItem('token');
    } catch (error) {
        console.error('Error getting auth token from session storage:', error);
        return null;
    }
}

export function clearAuthToken() {
    try {
        localStorage.setItem('token', '');
    } catch (error) {
        console.error('Error setting auth token in session storage:', error);
    }
}

export const getToken = () => {
    const config = localConfig().fetch();
    return config[LOCAL_STORAGE_KEYS.token];
};

export const getCurrentUser = () => {
    const config = localConfig().fetch();
    return config[LOCAL_STORAGE_KEYS.activeUser];
};

export const setCurrentUser = (userId) => {
    const config = localConfig().fetch();
    config.save([LOCAL_STORAGE_KEYS.activeUser], userId);
};
export const setCurrentUserRole = (userRole) => {
    const config = localConfig().fetch();
    config.save([LOCAL_STORAGE_KEYS.activeUserRole], userRole);
};

export const getCurrentUserRole = () => {
    const config = localConfig().fetch();
    return config[LOCAL_STORAGE_KEYS.activeUserRole];
};

export const resetActiveUser = () => {
    const config = localConfig().fetch();
    config.save([LOCAL_STORAGE_KEYS.token], undefined);
};
